module.exports = __webpack_public_path__ + "static/team-photo-workshop-eb44b5f893c490021ca00be8dbaf0fad.jpg";